module.exports = __webpack_public_path__ + "media/images/john-planting-d50fd928a7b2b1c22b981d83becb5ad8.png";